import React from "react";
import Link from "gatsby-link";
import { endSlash } from "../../util/helperFunctions";

const ButtonStd = ({ className, route, text }) => {
  return (
    <Link
      to={endSlash(route)}
      className={`${className} button--std db flex items-center justify-center bg-white dark hover-bg-stone bg-ease-out`}
    >
      {text}
    </Link>
  );
};

export default ButtonStd;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonStd.js